export enum ReferralUserType {
  Customer = 'customer',
  Affiliate = 'affiliate',
}

export enum ReferralReportTab {
  Stage1 = 'stage-1',
  Stage2 = 'stage-2',
}

export enum AffiliateReferralUserType {
  Customer = 'Customer',
  Affiliate = 'Affiliate',
}

export enum ReferralType {
  direct = 'Direct',
  indirect = 'Indirect',
}

export interface ReferralAnalytics {
  todaysReferrersCount: number;
  monthlyReferralCount: number;
  totalReferralCount: number;
  totalPointIssuedCount: number;
}

export interface AffiliateReferralReport {
  affiliateId: string;
  referCode: string;
  affiliateInfo: string;
  emailAddress: string;
  referredTo: string;
  userType: AffiliateReferralUserType;
  actionDate: number;
  rewardPoints: number | null;
  subDomainUrl: string;
  isFromSubDomain: boolean;
}

export interface AffiliateReferralReportParams {
  search?: string;
  fromDate?: number;
  toDate?: number;
  agentType?: string;
  row?: number;
  fetch?: number;
  referTypeFilter?: string;
  affiliateId?: string;
}

export interface CustomerReferralReportParams {
  search?: string;
  stageCode?: string;
  referrerCustomerId?: string;
  fromDateMs?: number;
  toDateMs?: number;
  row?: number;
  fetch?: number;
}

export interface CustomerReferralReport {
  referredCustomerId: string;
  referrerCustomerId: string;
  referrerCustomerNickname: string;
  referrerCustomerFullname: string;
  referredCustomerNickname: string;
  referredCustomerFullname: string;
  reservationDateTimeMs: number;
  rewardAmount: number | null;
  rewardTransactionDateTimeMs: number | null;
  stageDetail: string;
  stageDetailJp: string;
  referrerCustomerReferCode: string;
}

export interface ClubImage {
  alt?: string;
  description?: string;
  path?: string;
}
export interface CustomerReferralDetail {
  customerId: string;
  rewardPoints: string;
  reservedBy: string;
  storeName: string;
  storeNameJp: string;
  clubImage?: ClubImage | null;
  visitDateTime: number;
}
export interface AffiliateReferralDetail {
  affiliateId: string;
  affiliateInfo: string;
  emailAddress: string;
  reservedBy: string;
  referralType: string;
  visitDateTime: number;
  rewardPoints: number;
}
